export {IconComponent} from './icon.component';
export {LazyImgComponent} from './lazy-img.component';
export {LoaderComponent} from './loader/loader.component';
export {TruncatedTextComponent} from './truncated-text.component';
export {MiddleTruncateComponent} from './middle-truncate.component';
export {MessageComponent} from './message.component';
export {ButtonComponent} from './button/button.component';
export {EmptyComponent} from './empty.component';
